import React from "react";
import { useT } from "../lib/i18n";

// Compact pill switcher FR | EN.
// Variant: "header" (small) or "footer" (larger).
export default function LanguageSwitcher({ variant = "header" }) {
    const { lang, setLang } = useT();
    const baseBtn = variant === "footer"
        ? "px-3 py-1 font-display text-sm tracking-[0.18em] uppercase"
        : "px-2.5 py-1 font-display text-[11px] tracking-[0.18em] uppercase";
    return (
        <div
            data-testid={`lang-switcher-${variant}`}
            className="inline-flex items-center gap-0 border border-white/15 angle-tag overflow-hidden bg-black/40"
            role="group"
            aria-label="Language"
        >
            {["fr", "en"].map((code, i) => {
                const active = lang === code;
                return (
                    <button
                        key={code}
                        type="button"
                        onClick={() => setLang(code)}
                        data-testid={`lang-btn-${code}-${variant}`}
                        aria-pressed={active}
                        className={`${baseBtn} transition-colors ${active ? "bg-[#7FD93C] text-black" : "text-white/70 hover:text-white"} ${i === 1 ? "border-l border-white/15" : ""}`}
                    >
                        {code === "fr" ? "FR" : "EN"}
                    </button>
                );
            })}
        </div>
    );
}
